import { render, staticRenderFns } from "./gc-field-select.vue?vue&type=template&id=506cbe4c&scoped=true"
import script from "./gc-field-select.vue?vue&type=script&lang=js"
export * from "./gc-field-select.vue?vue&type=script&lang=js"
import style0 from "./gc-field-select.vue?vue&type=style&index=0&id=506cbe4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506cbe4c",
  null
  
)

export default component.exports